export function scrollIntoView(id: string) {
  const element = document.getElementById(id)
  if (element) {
    element.scrollIntoView({ behavior: 'smooth' })
  }
}

export function scrollToTop() {
  window.scroll({
    top: 0,
    behavior: 'smooth'
  })
}
